import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import Welcome from "./Component/welcome.jsx";
import Login from "./Component/login";
import $ from "jquery";
import Navbar from "./Component/navbar";
import Menu from "./Component/menu";
import Refahi from "./Component/pages/Refahi";
import Insurance from "./Component/pages/Insurance";
import LifeAccident from "./Component/pages/LifeAccident.js";
import Votes from "./Component/pages/Votes.js";
import Cermony from "./Component/pages/Cermony";
import Course from "./Component/pages/Course";
import Register from "./Component/pages/Register";
import Quran from "./Component/pages/Quran";
import Noor from "./Component/pages/Noor";
import Book from "./Component/pages/Book";
import EServices from "./Component/pages/EServices";
import Saham from "./Component/pages/Saham";
import Loan from "./Component/pages/Loan";
import UserSurvey from "./Component/pages/UserSurvey";
import Services from "./Component/pages/Services";
import Profile from "./Component/pages/Profile";
import Survey from "./Component/pages/SurveyView";
import Complaints from "./Component/pages/Complaints";
import ChatRooms from "./Component/pages/ChatRooms";
import Salary from "./Component/pages/Salary";
import FoodSurvey from "./Component/pages/FoodSurvey";
import Size from "./Component/pages/SizeClothe";
import Rahbar from "./Component/pages/RahbarTravel";

import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import BlockUi from "react-block-ui";
import "react-block-ui/style.css";
import { Fragment } from "react";
import RefahiCondition from "./MyFiles/RefahiCondition.jpg";

class SalcoAPP extends Component {
  state = {
    isRelationLoading: false,
    isNotice: false,
    blocking: false,
    isModal: false,
    isRelation: false,
    isUpdateRelation: false,
    isError: false,
    isLaw: false,
    isAlarm: false,
    isSurvey: false,
    isLogin: null,
    errorMessage: "",
    userJson: [],
    userLoanInfoJson: [],
    complaintsJson: [],
    usersurveyJson: [],
    complaintsDepartment: [],
    chatroomJson: [],
    calenderJson: [],
    calenderPlaceJson: [],
    calenderYearJson: [],
    calenderMonthJson: [],
    userLoanReason: [],
    userRequestJson: [],
    userRelationJson: [],
    userRelationsJson: [],
    userInsRequestJson: [],
    userCermonyRequestJson: [],
    userLoanRequestJson: [],
    cityJson: [],
    yearJson: [],
    monthJson: [],
    surveyJson: [],
    candidateJson: [],
    unSeen: 0,
  };

  componentDidMount() {
    console.log("APP-Mounted Salco");
    this.checkinLogin();
    const parms = window.location.pathname;
    if (parms === "/" || parms === "/login") return;
    else {
      this.getFullProfile();
      this.getChatMessageUnseen();
      //this.getUserRequest();
      //this.toggleNotice();
    }
  }

  render() {
    if (this.state.blocking) {
      return (
        <div className="body bg-light">
          <div className="row vh-100">
            <div className="cssload-thecube m-auto">
              <div className="cssload-cube cssload-c1"></div>
              <div className="cssload-cube cssload-c2"></div>
              <div className="cssload-cube cssload-c4"></div>
              <div className="cssload-cube cssload-c3"></div>
            </div>
          </div>
        </div>
      );
    } else if (this.state.isSurvey) {
      return (
        <div className="body">
          <Modal show={this.state.isError} onHide={this.toggleError}>
            <Modal.Header>
              <Modal.Title>مجتمع صنایع آلومینیوم جنوب</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="w-100 text-justify text">
                <p className="mb-0">{this.state.errorMessage}</p>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="btn btn-sm dina-btn-orange"
                onClick={this.toggleError}
              >
                تایید
              </Button>
            </Modal.Footer>
          </Modal>
          <div className="col-12 p-0 fixed-top nav-height bg-light">
            <Navbar userJson={this.state.userJson}></Navbar>
          </div>
          <div className="row">
            <Survey
              getUserRequest={this.getUserRequest}
              toggleSurvey={this.toggleSurvey}
              surveyJson={this.state.surveyJson}
              toggleError={this.toggleError}
              toggleErrorMessage={this.toggleErrorMessage}
            ></Survey>
          </div>
        </div>
      );
    } else {
      const listComplaintDepartment_Active = this.state.complaintsDepartment.map(
        (myList) => (
          <option key={myList.ID} value={myList.ID}>
            {myList.Title}
          </option>
        ),
      );
      const city_Active = this.state.cityJson.map((myList) => (
        <option key={myList.ID} value={myList.Title}>
          {myList.Title}
        </option>
      ));
      const year_Active = this.state.yearJson.map((myList) => (
        <option key={myList.ID} value={myList.ID}>
          {myList.Title}
        </option>
      ));
      return (
        // <Router>
        <div className="body">
          <Modal show={this.state.isAlarm} onHide={this.toggleAlarm}>
            <Modal.Header>
              <Modal.Title>مجتمع صنایع آلومینیوم جنوب</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="w-100 text-justify text">
                <h4 className="mb-2">همکاران گرامی</h4>
                <p className="mb-0">
                  از ساعت 18 امروز تا ساعت 24 سه شنبه 23 اسفند ماه 1401 ثبت نام
                  اولیه و رزرو سفر مشهد مقدس امکان پذیر خواهد بود.
                </p>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="btn btn-sm btn-danger"
                onClick={this.toggleAlarm}
              >
                تایید
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal show={this.state.isError} onHide={this.toggleError}>
            <Modal.Header>
              <Modal.Title>مجتمع صنایع آلومینیوم جنوب</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="w-100 text-justify text">
                <p className="mb-0">{this.state.errorMessage}</p>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="btn btn-sm dina-btn-orange"
                onClick={this.toggleError}
              >
                تایید
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal show={this.state.isLaw} onHide={this.isLaw}>
            <Modal.Header>
              <Modal.Title>مجتمع صنایع آلومینیوم جنوب</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="w-100 text-justify text">
                <a
                  rel="noopener noreferrer"
                  href={RefahiCondition}
                  target="_blank"
                >
                  <img
                    alt="Condition Refahi"
                    src={RefahiCondition}
                    className="w-100"
                  ></img>
                </a>
                {/* <p className="mb-2 text-center h4">باسمه تعالی</p>
                <p className="mb-0">
                  به اطلاع می رساند نظر به برقراری سفر زیارتی مشهد مقدس در یکسال
                  اخیر برای کارکنان و خانواده های محترم آنان و استقبال بی نظیر
                  همکاران از این سفر معنوی و بر اساس نتایج نظر سنجی، مقرر شد سفر
                  های رفاهی گسترش پیدا کرده و سفرهای سیاحتی به شهرهای کیش و شمال
                  کشور نیز افزوده شود که در حال حاضر شهرهای مشهد، چابکسر و رامسر
                  جهت ثبت نام در سامانه فعال می گردد.
                </p>
                <p className="mb-0">
                  از این رو عزیزان می توانند برای سال جدید، تنها یک انتخاب از
                  شهرهای فوق را داشته باشند که پس از قرعه کشی نتیجه از طریق واحد
                  رفاهی به متقاضی سفر اعلام خواهد شد.
                </p>
                <p className="mb-0">
                  لازم به ذکر است با توجه به موافقت مدیرعامل محترم، مدنظر است
                  هزینه ای بعنوان «کمک هزینه تردد» به هر نفر از اعضای خانواده
                  تحت تکفل همکار عازم به سفر پرداخت شود که مبلغ پیش بینی شده پس
                  از سفر وی به همراه حقوق واریز خواهد شد.
                </p>
                <p className="mb-0">موارد مورد تاکید::</p>
                <p className="mb-0 text-danger">
                  1- در ایام پیک، اولویت سفر با خانواده‌های دارای فرزند محصل
                  است.
                </p>
                <p className="mb-0 text-danger">
                  2- مدت اقامت 4 شب و 5 روز می باشد.
                </p>
                <p className="mb-0 text-danger">
                  3- تا 72 ساعت قبل از سفر امکان کنسلی وجود خواهد داشت و پس از
                  آن هزینه اقامت از حقوق متقاضی کسر خواهد شد.
                </p>
                <p className="mb-0 text-danger">
                  4- برای هرگونه درخواست اعم از لغو، افزودن همراه و... در مدت
                  کمتر از 72 ساعت تا سفر، می بایست مراتب مستقیماً به واحد رفاهی
                  اعلام گردد. در غیر اینصورت درخواست متقاضی اعمال نخواهد شد.
                </p>
                <p className="mb-0 text-danger">
                  5- هزینه اقامت بیش از ظرفیت اتاق به عهده متقاضی است.
                </p>
                <p className="mb-0 text-danger">
                  6- با توجه به محدودیت ظرفیت، تأکید می‌گردد همکاران محترم صرفاً
                  قادر به انجام یک سفر در دوره مقرر (دو سال) خواهند بود.
                </p> */}
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="btn btn-sm dina-btn-orange"
                onClick={this.toggleLaw}
              >
                موافقم
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal show={this.state.isModal} onHide={this.toggleModal}>
            <Modal.Header closeButton>
              <Modal.Title>پیشنهاد خود را مطرح کنید:</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="w-100 text-justify text mb-2">
                <p className="mb-0">
                  همکار گرامی جهت بهبود عملکرد سازمان پیشنهاد خود را به صورت
                  کامل مطرح نمایید.
                </p>
                <p className="mb-0">به زودی درخواست شما بررسی می شود.</p>
              </div>
              <div className="w-100 SN-box">
                <label className="dina-fc-blue">
                  واحد مربوطه<span className="text-danger mr-1">*</span>
                </label>
                <select
                  id="ComplaintDepartment_ID"
                  name="ComplaintDepartment_ID"
                  type="text"
                  className="form-select form-select-lg text-center wp-input-text rounded-0"
                  placeholder="واحد مربوطه"
                  defaultValue=""
                >
                  <option value="">انتخاب نمایید</option>
                  {listComplaintDepartment_Active}
                </select>
              </div>
              <div className="w-100 SN-box">
                <label className="dina-fc-blue">
                  عنوان پیشنهاد<span className="text-danger mr-1">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="ComplaintTitle"
                />
              </div>
              <div className="w-100 SN-box">
                <label className="dina-fc-blue">
                  دلایل ارائه پیشنهاد<span className="text-danger mr-1">*</span>
                  <br></br>
                  <small>(شرح مشکلات و نقص های فعلی)</small>
                </label>
                <textarea
                  rows="3"
                  type="text"
                  className="form-control"
                  id="ComplaintReason"
                />
              </div>
              <div className="w-100 SN-box">
                <label className="dina-fc-blue">
                  شرح پیشنهاد<span className="text-danger mr-1">*</span>
                  <br></br>
                  <small>
                    (راهکار اجرایی برای بهبود فرآیند یا رفع مشکل و نقص ها)
                  </small>
                </label>
                <textarea
                  rows="6"
                  type="text"
                  className="form-control"
                  id="ComplaintDescribe"
                />
              </div>
              <div className="w-100 mb-2 text-center">
                <div className="bg-danger text-white w-100">
                  <label className="text-white">بارگذاری سند</label>
                  <input
                    type="file"
                    id="inputDoc"
                    className="file"
                    accept="image/*, application/pdf"
                    onChange={() => this.handleFileSelect("inputDoc")}
                  ></input>
                  <label
                    htmlFor="inputDoc"
                    className="btn btn-light rounded-0 d-flex btn-sm file-lable"
                  >
                    انتخاب فایل...
                  </label>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="btn btn-sm dina-btn-orange"
                onClick={this.addComplaint}
              >
                ثبت نظر
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal show={this.state.isRelation} onHide={this.toggleRelation}>
            <Modal.Header closeButton>
              <Modal.Title>افزودن فرد تحت تکفل</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="w-100 text-justify text mb-2">
                <p className="mb-0">
                  اطلاعات اعضای خانوار خود را به صورت کامل وارد نمایید.
                </p>
              </div>
              <div className="w-100 SN-box">
                <label className="dina-fc-blue">
                  جنسیت<span className="text-danger mr-1">*</span>
                </label>
                <select
                  id="Sex"
                  name="Sex"
                  type="text"
                  className="form-select form-select-lg text-center wp-input-text rounded-0"
                  placeholder="جنسیت"
                  defaultValue=""
                >
                  <option value="">جنسیت را انتخاب کنید</option>
                  <option key="1" value="آقا">
                    آقا
                  </option>
                  <option key="2" value="خانم">
                    خانم
                  </option>
                </select>
              </div>
              <div className="w-100 SN-box">
                <label className="dina-fc-blue">
                  نسبت<span className="text-danger mr-1">*</span>
                </label>
                <select
                  id="Relation_ID"
                  name="Relation_ID"
                  type="text"
                  className="form-select form-select-lg text-center wp-input-text rounded-0"
                  placeholder="جنسیت"
                  defaultValue=""
                >
                  <option value="">نسبت را انتخاب کنید</option>
                  <option key="1" value="1">
                    پدر
                  </option>
                  <option key="2" value="2">
                    مادر
                  </option>
                  <option key="10" value="10">
                    همسر
                  </option>
                  <option key="11" value="11">
                    فرزند
                  </option>
                </select>
              </div>
              <div className="w-100 SN-box">
                <label className="dina-fc-blue">
                  نام<span className="text-danger mr-1">*</span>
                </label>
                <input type="text" className="form-control" id="F_Name" />
              </div>
              <div className="w-100 SN-box">
                <label className="dina-fc-blue">
                  نام خانوادگی<span className="text-danger mr-1">*</span>
                </label>
                <input type="text" className="form-control" id="L_Name" />
              </div>
              <div className="w-100 SN-box">
                <label className="dina-fc-blue">
                  نام پدر<span className="text-danger mr-1">*</span>
                </label>
                <input type="text" className="form-control" id="FA_Name" />
              </div>
              <div className="w-100 SN-box">
                <label className="dina-fc-blue">
                  کد ملی<span className="text-danger mr-1">*</span>
                </label>
                <input
                  type="text"
                  maxLength={10}
                  className="form-control"
                  id="National_Code"
                />
              </div>
              <div className="w-100 SN-box">
                <label className="dina-fc-blue">
                  شماره شناسنامه<span className="text-danger mr-1">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="Identity_Code"
                  maxLength={10}
                />
              </div>
              <div className="w-100 SN-box">
                <label className="dina-fc-blue">
                  تاریخ تولد<span className="text-danger mr-1">*</span>
                </label>
                <div className="row">
                  <div className="col-3">
                    <label className="wp-text-sm">روز</label>
                    <select
                      id="DayOfBirthday"
                      name="DayOfBirthday"
                      className="form-select text-left"
                    >
                      <option value=""></option>
                      <option key="1" value="01">
                        1
                      </option>
                      <option key="2" value="02">
                        2
                      </option>
                      <option key="3" value="03">
                        3
                      </option>
                      <option key="4" value="04">
                        4
                      </option>
                      <option key="5" value="05">
                        5
                      </option>
                      <option key="6" value="06">
                        6
                      </option>
                      <option key="7" value="07">
                        7
                      </option>
                      <option key="8" value="08">
                        8
                      </option>
                      <option key="9" value="09">
                        9
                      </option>
                      <option key="10" value="10">
                        10
                      </option>
                      <option key="11" value="11">
                        11
                      </option>
                      <option key="12" value="12">
                        12
                      </option>
                      <option key="13" value="13">
                        13
                      </option>
                      <option key="14" value="14">
                        14
                      </option>
                      <option key="15" value="15">
                        15
                      </option>
                      <option key="16" value="16">
                        16
                      </option>
                      <option key="17" value="17">
                        17
                      </option>
                      <option key="18" value="18">
                        18
                      </option>
                      <option key="19" value="19">
                        19
                      </option>
                      <option key="20" value="20">
                        20
                      </option>
                      <option key="21" value="21">
                        21
                      </option>
                      <option key="22" value="22">
                        22
                      </option>
                      <option key="23" value="23">
                        23
                      </option>
                      <option key="24" value="24">
                        24
                      </option>
                      <option key="25" value="25">
                        25
                      </option>
                      <option key="26" value="26">
                        26
                      </option>
                      <option key="27" value="27">
                        27
                      </option>
                      <option key="28" value="28">
                        28
                      </option>
                      <option key="29" value="29">
                        29
                      </option>
                      <option key="30" value="30">
                        30
                      </option>
                      <option key="31" value="31">
                        31
                      </option>
                    </select>
                  </div>
                  <div className="col-4">
                    <label className="wp-text-sm">ماه</label>
                    <select
                      id="MonthOfBirthday"
                      name="MonthOfBirthday"
                      className="form-select text-left"
                    >
                      <option value=""></option>
                      <option key="1" value="01">
                        فروردین
                      </option>
                      <option key="2" value="02">
                        اردیبهشت
                      </option>
                      <option key="3" value="03">
                        خرداد
                      </option>
                      <option key="4" value="04">
                        تیر
                      </option>
                      <option key="5" value="05">
                        مرداد
                      </option>
                      <option key="6" value="06">
                        شهریور
                      </option>
                      <option key="7" value="07">
                        مهر
                      </option>
                      <option key="8" value="08">
                        آبان
                      </option>
                      <option key="9" value="09">
                        آذر
                      </option>
                      <option key="10" value="10">
                        دی
                      </option>
                      <option key="11" value="11">
                        بهمن
                      </option>
                      <option key="12" value="12">
                        اسفند
                      </option>
                    </select>
                  </div>
                  <div className="col-5">
                    <label className="wp-text-sm">سال</label>
                    <select
                      id="YearOfBirthday"
                      name="YearOfBirthday"
                      className="form-select text-left"
                    >
                      <option value=""></option>
                      {year_Active}
                    </select>
                  </div>
                </div>
              </div>
              <div className="w-100 SN-box">
                <label className="dina-fc-blue">
                  محل صدور<span className="text-danger mr-1">*</span>
                </label>
                <select
                  id="Sodor_City"
                  name="Sodor_City"
                  className="form-select text-left"
                >
                  <option value=""></option>
                  {city_Active}
                </select>
              </div>
              <div className="w-100 mt-1">
                <div className="form-check text-right">
                  <input
                    className="form-check-input TaminPerson"
                    type="checkbox"
                    value="on"
                    id="flexCheckDefault"
                  ></input>
                  <label
                    className="form-check-label"
                    htmlFor="flexCheckDefault"
                  >
                    تحت پوشش تأمین اجتماعی من است.
                  </label>
                </div>
              </div>
              <div className="row">
                <div className="col-6 mt-2 text-center">
                  <div className="bg-danger text-white w-100">
                    <label>شناسنامه</label><br />
                    <input type="file" id="inputIdentity" className="file" accept="image/*, application/pdf" onChange={() => this.handleFileSelect("inputIdentity")}></input>
                    <label htmlFor="inputIdentity" className="btn btn-light rounded-0 d-flex btn-sm file-lable">انتخاب فایل...</label>
                  </div>
                </div>
                <div className="col-6 mt-2 text-center">
                  <div className="bg-danger text-white w-100">
                    <label>کارت ملی</label><br />
                    <input type="file" id="inputMeli" className="file" accept="image/*, application/pdf" onChange={() => this.handleFileSelect("inputMeli")}></input>
                    <label htmlFor="inputMeli" className="btn btn-light rounded-0 d-flex btn-sm file-lable">انتخاب فایل...</label>
                  </div>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              {this.state.isRelationLoading && (
                <Button className="btn btn-sm btn-warning">
                  در حال ارسال...
                </Button>
              )}
              {!this.state.isRelationLoading && (
                <Button
                  className="btn btn-sm btn-primary"
                  onClick={() =>
                    this.addRelation()
                  }
                >
                  ارسال اطلاعات
                </Button>
              )}
            </Modal.Footer>
          </Modal>
          <Modal
            show={this.state.isUpdateRelation}
            onHide={this.toggleUpdateRelation}
          >
            <Modal.Header closeButton>
              <Modal.Title>ویرایش اعضای خانوار</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="w-100 text-justify text mb-2">
                <p className="mb-0">
                  اطلاعات خانوار خودت را به درستی وارد نمایید.
                </p>
              </div>
              <div className="w-100 SN-box">
                <label className="dina-fc-blue">
                  جنسیت<span className="text-danger mr-1">*</span>
                </label>
                <select
                  id="Sex_Edit"
                  type="text"
                  className="form-select form-select-lg text-center wp-input-text rounded-0"
                  placeholder="جنسیت"
                  defaultValue=""
                >
                  <option value={this.state.userRelationJson.Sex}>
                    انتخاب شده - {this.state.userRelationJson.Sex}
                  </option>
                  <option key="1" value="آقا">
                    آقا
                  </option>
                  <option key="2" value="خانم">
                    خانم
                  </option>
                </select>
              </div>
              <div className="w-100 SN-box">
                <label className="dina-fc-blue">
                  نسبت<span className="text-danger mr-1">*</span>
                </label>
                <select
                  id="Relation_ID_Edit"
                  type="text"
                  className="form-select form-select-lg text-center wp-input-text rounded-0"
                  placeholder="جنسیت"
                  defaultValue=""
                >
                  <option value={this.state.userRelationJson.Relation_ID}>
                    انتخاب شده
                  </option>
                  <option key="1" value="1">
                    پدر
                  </option>
                  <option key="2" value="2">
                    مادر
                  </option>
                  <option key="10" value="10">
                    همسر
                  </option>
                  <option key="11" value="11">
                    فرزند
                  </option>
                </select>
              </div>
              <div className="w-100 SN-box">
                <label className="dina-fc-blue">
                  نام<span className="text-danger mr-1">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="F_Name_Edit"
                  defaultValue={this.state.userRelationJson.F_Name}
                />
              </div>
              <div className="w-100 SN-box">
                <label className="dina-fc-blue">
                  نام خانوادگی<span className="text-danger mr-1">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="L_Name_Edit"
                  defaultValue={this.state.userRelationJson.L_Name}
                />
              </div>
              <div className="w-100 SN-box">
                <label className="dina-fc-blue">
                  نام پدر<span className="text-danger mr-1">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="FA_Name_Edit"
                  defaultValue={this.state.userRelationJson.FA_Name}
                />
              </div>
              <div className="w-100 SN-box">
                <label className="dina-fc-blue">
                  کد ملی<span className="text-danger mr-1">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="National_Code_Edit"
                  defaultValue={this.state.userRelationJson.National_Code}
                />
              </div>
              <div className="w-100 SN-box">
                <label className="dina-fc-blue">
                  شماره شناسنامه<span className="text-danger mr-1">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="Identity_Code_Edit"
                  defaultValue={this.state.userRelationJson.Identity_Code}
                />
              </div>
              <div className="w-100 SN-box">
                <label className="dina-fc-blue">
                  تاریخ تولد<span className="text-danger mr-1">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="DateOfBirthday_Edit"
                  defaultValue={this.state.userRelationJson.DateOfBirthday}
                  placeholder="1369/06/29"
                />
                <small className="text-danger">
                  تاریخ را به صورت صحیح وارد نمایید. مثلا 1369/06/09
                </small>
              </div>
              <div className="w-100 SN-box">
                <label className="dina-fc-blue">
                  محل صدور<span className="text-danger mr-1">*</span>
                </label>
                <select
                  id="Sodor_City_Edit"
                  className="form-select form-select-lg text-center wp-input-text rounded-0"
                >
                  <option value={this.state.userRelationJson.Sodor_City}>
                    انتخاب شده - {this.state.userRelationJson.Sodor_City}
                  </option>
                  {city_Active}
                </select>
              </div>
              <div className="row">
                <div className="col-6 mt-2 text-center">
                  <div className="bg-danger text-white w-100">
                    <label>شناسنامه</label><br />
                    <input type="file" id="inputIdentity_Edit" className="file" accept="image/*, application/pdf" onChange={() => this.handleFileSelect("inputIdentity_Edit")}></input>
                    <label htmlFor="inputIdentity_Edit" className="btn btn-light rounded-0 d-flex btn-sm file-lable">انتخاب فایل...</label>
                  </div>
                </div>
                <div className="col-6 mt-2 text-center">
                  <div className="bg-danger text-white w-100">
                    <label>کارت ملی</label><br />
                    <input type="file" id="inputMeli_Edit" className="file" accept="image/*, application/pdf" onChange={() => this.handleFileSelect("inputMeli_Edit")}></input>
                    <label htmlFor="inputMeli_Edit" className="btn btn-light rounded-0 d-flex btn-sm file-lable">انتخاب فایل...</label>
                  </div>
                </div>
              </div>
              {/* <div className="w-100 mt-1">
                  <div className="form-check text-right">
                      <input className="form-check-input TaminPerson" type="checkbox" value="on" id="flexCheckDefault"></input>
                      <label className="form-check-label" htmlFor="flexCheckDefault">تحت پوشش تأمین اجتماعی من است.</label>
                  </div>
                </div> */}
            </Modal.Body>
            <Modal.Footer>
              {this.state.isRelationLoading && (
                <Button className="btn btn-sm btn-warning">
                  در حال ارسال...
                </Button>
              )}
              {!this.state.isRelationLoading && (
                <Button
                  className="btn btn-sm btn-primary"
                  onClick={() =>
                    this.editRelation(this.state.userRelationJson.ID)
                  }
                >
                  ارسال اطلاعات
                </Button>
              )}
            </Modal.Footer>
          </Modal>
          <Switch>
            <Route path="/" exact>
              <Welcome
                handleVideoEnded={this.handleVideoEnded}
                checkinLogin={this.checkinLogin}
              />
            </Route>
            <Route path="/login" exact>
              <Login
                handleLogin={this.handleLogin}
                toggleError={this.toggleError}
                toggleErrorMessage={this.toggleErrorMessage}
              />
            </Route>
            <Route path="/chat" exact>
              <div className="col-12 p-0 fixed-top nav-height bg-light">
                <Navbar userJson={this.state.userJson}></Navbar>
              </div>
              <div className="col-12 p-0">
                <ChatRooms
                  getChatMessageUnseen={this.getChatMessageUnseen}
                  toggleError={this.toggleError}
                  toggleErrorMessage={this.toggleErrorMessage}
                  chatroomJson={this.state.chatroomJson}
                />
              </div>
              <div className="col-12 p-0 fixed-bottom">
                <Menu unSeen={this.state.unSeen}></Menu>
              </div>
            </Route>
            <Route path="/profile">
              <div className="col-12 feed-body">
                <Profile
                  getFullProfile={this.getFullProfile}
                  saveFullProfile={this.saveFullProfile}
                  userJson={this.state.userJson}
                  toggleError={this.toggleError}
                  toggleErrorMessage={this.toggleErrorMessage}
                  handleLouOut={this.handleLouOut}
                ></Profile>
              </div>
              <div className="col-12 p-0 fixed-bottom">
                <Menu unSeen={this.state.unSeen}></Menu>
              </div>
            </Route>
            <Route path="/complaints">
              <div className="col-12 p-0 fixed-top nav-height bg-light">
                <Navbar userJson={this.state.userJson}></Navbar>
              </div>
              <div className="col-12 feed-body">
                <Complaints
                  toggleModal={this.toggleModal}
                  complaintsJson={this.state.complaintsJson}
                  getComplaintsDepartment={this.getComplaintsDepartment}
                  getUserComplaints={this.getUserComplaints}
                ></Complaints>
              </div>
              <div className="col-12 p-0 fixed-bottom">
                <Menu unSeen={this.state.unSeen}></Menu>
              </div>
            </Route>
            <Route path="/home">
              <Fragment>
                <BlockUi
                  tag="div"
                  className="row"
                  blocking={this.state.blocking}
                >
                  <div className="col-12 p-0 fixed-top nav-height bg-light">
                    <Navbar userJson={this.state.userJson}></Navbar>
                  </div>
                  <div className="col-12 feed-body o-y-scroll">
                    <Route path="/home/" exact>
                      <Services userJson={this.state.userJson}></Services>
                    </Route>
                    <Route path="/home/salary" exact>
                      <Salary
                        toggleError={this.toggleError}
                        toggleErrorMessage={this.toggleErrorMessage}
                        getSalaryYear={this.getSalaryYear}
                        getSalaryMonth={this.getSalaryMonth}
                        yearJson={this.state.yearJson}
                        monthJson={this.state.monthJson}
                      ></Salary>
                    </Route>
                    <Route path="/home/refahi" exact>
                      <Refahi
                        participateSurvey={this.participateSurvey}
                        declineRequest={this.declineRequest}
                        acceptReservation={this.acceptReservation}
                        getUserRequest={this.getUserRequest}
                        userRequestJson={this.state.userRequestJson}
                        clearCalender={this.clearCalender}
                        toggleError={this.toggleError}
                        toggleErrorMessage={this.toggleErrorMessage}
                        toggleBlocking={this.toggleBlocking}
                        toggleSubmitForce={this.toggleSubmitForce}
                        toggleLaw={this.toggleLaw}
                        toggleAlarm={this.toggleAlarm}
                        getCalenderPlace={this.getCalenderPlace}
                        getCalenderYear={this.getCalenderYear}
                        getCalenderMonth={this.getCalenderMonth}
                        getCalender={this.getCalender}
                        calenderJson={this.state.calenderJson}
                        calenderPlaceJson={this.state.calenderPlaceJson}
                        calenderYearJson={this.state.calenderYearJson}
                        calenderMonthJson={this.state.calenderMonthJson}
                      ></Refahi>
                    </Route>
                    <Route path="/home/insurance" exact>
                      <Insurance
                        toggleError={this.toggleError}
                        toggleErrorMessage={this.toggleErrorMessage}
                        userInsRequestJson={this.state.userInsRequestJson}
                        userRelationsJson={this.state.userRelationsJson}
                        getAllUserRelation={this.getAllUserRelation}
                        userJson={this.state.userJson}
                        toggleRelation={this.toggleRelation}
                        getUserRelation={this.getUserRelation}
                        getUserInsRequest={this.getUserInsRequest}
                      ></Insurance>
                    </Route>
                    <Route path="/home/lifeAccident" exact>
                      <LifeAccident
                        toggleError={this.toggleError}
                        toggleErrorMessage={this.toggleErrorMessage}
                        getAllUserRelation={this.getAllUserRelation}
                        userRelationsJson={this.state.userRelationsJson}
                        getUserInsRequest={this.getUserInsRequest}
                        userInsRequestJson={this.state.userInsRequestJson}
                      >
                      </LifeAccident>
                    </Route>
                    <Route path="/home/vote" exact>
                      <Votes
                        toggleError={this.toggleError}
                        toggleErrorMessage={this.toggleErrorMessage}
                        candidateJson={this.state.candidateJson}
                        getAllCandidate={this.getAllCandidate}
                      ></Votes>
                    </Route>
                    <Route path="/home/cermony" exact>
                      <Cermony
                        toggleError={this.toggleError}
                        toggleErrorMessage={this.toggleErrorMessage}
                        userCermonyRequestJson={
                          this.state.userCermonyRequestJson
                        }
                        userRelationsJson={this.state.userRelationsJson}
                        getAllUserRelation={this.getAllUserRelation}
                        userJson={this.state.userJson}
                        toggleRelation={this.toggleRelation}
                        getUserRelation={this.getUserRelation}
                        getUserCermonyRequest={this.getUserCermonyRequest}
                      ></Cermony>
                    </Route>
                    <Route path="/home/course" exact>
                      <Course
                        toggleError={this.toggleError}
                        toggleErrorMessage={this.toggleErrorMessage}
                        userCermonyRequestJson={
                          this.state.userCermonyRequestJson
                        }
                        userRelationsJson={this.state.userRelationsJson}
                        getAllUserRelation={this.getAllUserRelation}
                        userJson={this.state.userJson}
                        toggleRelation={this.toggleRelation}
                        getUserRelation={this.getUserRelation}
                        getUserCermonyRequest={this.getUserCermonyRequest}
                      ></Course>
                    </Route>
                    <Route path="/home/foodSurvey" exact>
                      <FoodSurvey
                        toggleError={this.toggleError}
                        toggleErrorMessage={this.toggleErrorMessage}
                        userJson={this.state.userJson}
                      ></FoodSurvey>
                    </Route>
                    <Route path="/home/register" exact>
                      <Register
                        toggleError={this.toggleError}
                        toggleErrorMessage={this.toggleErrorMessage}
                        userRelationsJson={this.state.userRelationsJson}
                        getAllUserRelation={this.getAllUserRelation}
                        userJson={this.state.userJson}
                        toggleRelation={this.toggleRelation}
                        getUserRelation={this.getUserRelation}
                      ></Register>
                    </Route>
                    <Route path="/home/quran" exact>
                      <Quran
                        toggleError={this.toggleError}
                        toggleErrorMessage={this.toggleErrorMessage}
                        userRelationsJson={this.state.userRelationsJson}
                        getAllUserRelation={this.getAllUserRelation}
                        userJson={this.state.userJson}
                        toggleRelation={this.toggleRelation}
                        getUserRelation={this.getUserRelation}
                      ></Quran>
                    </Route>
                    <Route path="/home/noor" exact>
                      <Noor
                        toggleError={this.toggleError}
                        toggleErrorMessage={this.toggleErrorMessage}
                        userRelationsJson={this.state.userRelationsJson}
                        getAllUserRelation={this.getAllUserRelation}
                        userJson={this.state.userJson}
                        toggleRelation={this.toggleRelation}
                        getUserRelation={this.getUserRelation}
                        toggleBlocking={this.toggleBlocking}
                      ></Noor>
                    </Route>
                    <Route path="/home/book" exact>
                      <Book
                        toggleError={this.toggleError}
                        toggleErrorMessage={this.toggleErrorMessage}
                        userRelationsJson={this.state.userRelationsJson}
                        getAllUserRelation={this.getAllUserRelation}
                        userJson={this.state.userJson}
                        toggleRelation={this.toggleRelation}
                        getUserRelation={this.getUserRelation}
                      ></Book>
                    </Route>
                    <Route path="/home/EServices" exact>
                      <EServices
                        toggleError={this.toggleError}
                        toggleErrorMessage={this.toggleErrorMessage}
                        userJson={this.state.userJson}
                      ></EServices>
                    </Route>
                    <Route path="/home/saham" exact>
                      <Saham
                        toggleError={this.toggleError}
                        toggleErrorMessage={this.toggleErrorMessage}
                        userJson={this.state.userJson}
                        getFullProfile={this.getFullProfile}
                      ></Saham>
                    </Route>
                    <Route path="/home/size" exact>
                      <Size
                        toggleError={this.toggleError}
                        toggleErrorMessage={this.toggleErrorMessage}
                        userJson={this.state.userJson}
                        getFullProfile={this.getFullProfile}
                      ></Size>
                    </Route>
                    <Route path="/home/rahbar" exact>
                      <Rahbar
                        toggleError={this.toggleError}
                        toggleErrorMessage={this.toggleErrorMessage}
                        userJson={this.state.userJson}
                        getFullProfile={this.getFullProfile}
                      ></Rahbar>
                    </Route>
                    <Route path="/home/loan" exact>
                      <Loan
                        declineLoanRequest={this.declineLoanRequest}
                        SubmitLoanRequest={this.SubmitLoanRequest}
                        getLoanReason={this.getLoanReason}
                        userLoanReason={this.state.userLoanReason}
                        getUserLoanRequest={this.getUserLoanRequest}
                        userLoanRequestJson={this.state.userLoanRequestJson}
                        getUserLoanInfo={this.getUserLoanInfo}
                        userLoanInfoJson={this.state.userLoanInfoJson}
                        toggleError={this.toggleError}
                        toggleErrorMessage={this.toggleErrorMessage}
                        toggleBlocking={this.toggleBlocking}
                      ></Loan>
                    </Route>
                    <Route path="/home/survey" exact>
                      <UserSurvey
                        participateSurvey={this.participateSurvey}
                        getallUserSurvey={this.getallUserSurvey}
                        usersurveyJson={this.state.usersurveyJson}
                        toggleError={this.toggleError}
                        toggleErrorMessage={this.toggleErrorMessage}
                        toggleBlocking={this.toggleBlocking}
                      ></UserSurvey>
                    </Route>
                  </div>
                  <div className="col-12 p-0 fixed-bottom bg-light nav-height">
                    <Menu unSeen={this.state.unSeen}></Menu>
                  </div>
                </BlockUi>
              </Fragment>
            </Route>
          </Switch>
        </div>
        // </Router>
      );
    }
  }

  handleVideoEnded = () => {
    console.log(localStorage.getItem("token"));
    if (this.state.isLogin === true) return (window.location = "/home");
    else return (window.location = "/login");
  };
  handleLogin = (e) => {
    localStorage.setItem("token", e.data.token);
    return (window.location = "/home");
  };
  handleLouOut = () => {
    const token = localStorage.getItem("token");
    if (token != null) {
      localStorage.clear();
      return (window.location = "/");
    }
  };
  toggleBlocking = () => {
    this.setState({ blocking: !this.state.blocking });
  };
  toggleNotice = () => {
    this.setState({ isNotice: !this.state.isNotice });
  };
  toggleModal = () => {
    this.setState({ isModal: !this.state.isModal });
  };
  toggleRelation = () => {
    if (this.state.cityJson.length === 0) {
      this.getCity();
    }
    if (this.state.yearJson.length === 0) {
      this.getYear();
    }
    this.setState({ isRelation: !this.state.isRelation });
  };
  toggleUpdateRelation = () => {
    this.setState({ isUpdateRelation: !this.state.isUpdateRelation });
  };
  toggleErrorMessage = (e) => {
    if (e !== null) this.setState({ errorMessage: e });
  };
  toggleError = () => {
    this.setState({ isError: !this.state.isError });
  };
  toggleSurvey = () => {
    this.setState({ isSurvey: !this.state.isSurvey });
  };
  toggleLaw = () => {
    this.setState({ isLaw: !this.state.isLaw });
  };
  toggleAlarm = () => {
    this.setState({ isAlarm: !this.state.isAlarm });
  };
  handleFileSelect = (el) => {
    var evt = document.getElementById(el);
    if (evt.files && evt.files.length > 0) {
      var item = $(evt).parent();
      $(item)
        .addClass("bg-success")
        .removeClass("bg-danger");
      $("label[for=" + evt.id + "]").text("انتخاب شد");
      //var res = $(item).next().find('label').text();
      //console.log(evt.target.id);
    }
  };
  addRelation = () => {
    const token = localStorage.getItem("token");
    if (token !== null) {
      var identity = $('#inputIdentity').prop('files')[0];
      var meli = $('#inputMeli').prop('files')[0];
      if (identity && meli) {
        if (identity.size <= 10080000 && meli.size <= 10080000) {
          const Sex = document.getElementById("Sex").value;
          if (Sex !== null && Sex !== "") {
            const Relation_ID = document.getElementById("Relation_ID").value;
            if (Relation_ID !== null && Relation_ID !== "") {
              const F_Name = document.getElementById("F_Name").value;
              if (F_Name !== null && F_Name !== "") {
                const L_Name = document.getElementById("L_Name").value;
                if (L_Name !== null && L_Name !== "") {
                  const FA_Name = document.getElementById("FA_Name").value;
                  if (FA_Name !== null && FA_Name !== "") {
                    const National_Code = document.getElementById("National_Code")
                      .value;
                    if (National_Code !== null && National_Code !== "") {
                      const Identity_Code = document.getElementById("Identity_Code")
                        .value;
                      if (Identity_Code !== null && Identity_Code !== "") {
                        const DayOfBirthday = document.getElementById(
                          "DayOfBirthday",
                        ).value;
                        const MonthOfBirthday = document.getElementById(
                          "MonthOfBirthday",
                        ).value;
                        const YearOfBirthday = document.getElementById(
                          "YearOfBirthday",
                        ).value;

                        if (
                          (DayOfBirthday !== null && DayOfBirthday !== "") ||
                          (MonthOfBirthday !== null && MonthOfBirthday !== "") ||
                          (YearOfBirthday !== null && YearOfBirthday !== "")
                        ) {
                          const DateOfBirthday =
                            YearOfBirthday +
                            "/" +
                            MonthOfBirthday +
                            "/" +
                            DayOfBirthday;
                          const Sodor_City = document.getElementById("Sodor_City")
                            .value;
                          if (Sodor_City !== null && Sodor_City !== "") {
                            this.setState({ isRelationLoading: true });
                            //this.toggleBlocking();
                            var TaminPersonChecked = document.querySelector(
                              ".TaminPerson:checked",
                            );
                            const TaminPerson =
                              TaminPersonChecked === null ||
                                TaminPersonChecked === ""
                                ? false
                                : true;
                            var formdata = new FormData();
                            formdata.append("token", token);
                            formdata.append("ID", 0);
                            formdata.append("Sex", Sex);
                            formdata.append("Relation_ID", Relation_ID);
                            formdata.append("F_Name", F_Name);
                            formdata.append("L_Name", L_Name);
                            formdata.append("FA_Name", FA_Name);
                            formdata.append("National_Code", National_Code);
                            formdata.append("Identity_Code", Identity_Code);
                            formdata.append("DateOfBirthday", DateOfBirthday);
                            formdata.append("Sodor_City", Sodor_City);
                            formdata.append("TaminPerson", TaminPerson);
                            formdata.append("identity", identity);
                            formdata.append("meli", meli);

                            var requestOptions = {
                              method: "POST",
                              body: formdata,
                              redirect: "follow",
                            };

                            fetch(
                              `${process.env.REACT_APP_BASE_API_URL}/api/user/update-relation`,
                              requestOptions,
                            )
                              .then((response) => response.text())
                              .then((result) => {
                                //this.toggleBlocking();
                                if (result !== null) {
                                  var myObject = JSON.parse(result);
                                  if (myObject.status === 0) {
                                    this.setState(
                                      { errorMessage: "عضو جدید در سیستم ثبت شد." },
                                      function () {
                                        this.toggleError();
                                      },
                                    );
                                    this.setState({ isRelationLoading: false });
                                    this.getAllUserRelation();
                                  } else {
                                    this.setState(
                                      { errorMessage: myObject.message },
                                      function () {
                                        this.toggleError();
                                      },
                                    );
                                    this.setState({ isRelationLoading: false });
                                  }
                                }
                              })
                              .catch((error) => console.log("error", error));
                          } else {
                            const errorMessage =
                              "محل صدور تحت تکفل خود را مشخص نمایید.";
                            this.toggleErrorMessage(errorMessage);
                            this.toggleError();
                          }
                        } else {
                          const errorMessage =
                            "تاریخ تولد تحت تکفل را وارد نمایید.";
                          this.toggleErrorMessage(errorMessage);
                          this.toggleError();
                        }
                      } else {
                        const errorMessage =
                          "شماره شناسنامه تحت تکفل را وارد نمایید.";
                        this.toggleErrorMessage(errorMessage);
                        this.toggleError();
                      }
                    } else {
                      const errorMessage = "کدملی تحت تکفل را وارد نمایید.";
                      this.toggleErrorMessage(errorMessage);
                      this.toggleError();
                    }
                  } else {
                    const errorMessage = "نام پدر را وارد نمایید.";
                    this.toggleErrorMessage(errorMessage);
                    this.toggleError();
                  }
                } else {
                  const errorMessage = "نام خانوادگی تحت تکفل را وارد نمایید.";
                  this.toggleErrorMessage(errorMessage);
                  this.toggleError();
                }
              } else {
                const errorMessage = "نام تحت تکفل را وارد نمایید.";
                this.toggleErrorMessage(errorMessage);
                this.toggleError();
              }
            } else {
              const errorMessage = "نسبت فرد را انتخاب نمایید.";
              this.toggleErrorMessage(errorMessage);
              this.toggleError();
            }
          }
          else {
            const errorMessage = "جنسیت را انتخاب نمایید.";
            this.toggleErrorMessage(errorMessage);
            this.toggleError();
          }
        }
      }
      else {
        const errorMessage = "بارگذاری مدارک شناسایی الزامی است.";
        this.toggleErrorMessage(errorMessage);
        this.toggleError();
      }
    }
  };
  editRelation = (e) => {
    const token = localStorage.getItem("token");
    if (token !== null) {
      var identity = $('#inputIdentity_Edit').prop('files')[0];
      var meli = $('#inputMeli_Edit').prop('files')[0];
      if (identity && meli) {
        if (identity.size <= 10080000 && meli.size <= 10080000) {
          const Sex = document.getElementById("Sex_Edit").value;
          if (Sex !== null && Sex !== "") {
            const Relation_ID = document.getElementById("Relation_ID_Edit").value;
            if (Relation_ID !== null && Relation_ID !== "") {
              const F_Name = document.getElementById("F_Name_Edit").value;
              if (F_Name !== null && F_Name !== "") {
                const L_Name = document.getElementById("L_Name_Edit").value;
                if (L_Name !== null && L_Name !== "") {
                  const FA_Name = document.getElementById("FA_Name_Edit").value;
                  if (FA_Name !== null && FA_Name !== "") {
                    const National_Code = document.getElementById(
                      "National_Code_Edit",
                    ).value;
                    if (National_Code !== null && National_Code !== "") {
                      const Identity_Code = document.getElementById(
                        "Identity_Code_Edit",
                      ).value;
                      if (Identity_Code !== null && Identity_Code !== "") {
                        const DateOfBirthday = document.getElementById(
                          "DateOfBirthday_Edit",
                        ).value;
                        if (DateOfBirthday !== null && DateOfBirthday !== "") {
                          const Sodor_City = document.getElementById(
                            "Sodor_City_Edit",
                          ).value;
                          if (Sodor_City !== null && Sodor_City !== "") {
                            this.setState({ isRelationLoading: true });
                            //this.toggleBlocking();
                            // var TaminPersonChecked = document.querySelector('.TaminPerson:checked');
                            // const TaminPerson = (TaminPersonChecked === null || TaminPersonChecked === "") ? false : true;
                            var formdata = new FormData();
                            formdata.append("token", token);
                            formdata.append("ID", e);
                            formdata.append("Sex", Sex);
                            formdata.append("Relation_ID", Relation_ID);
                            formdata.append("F_Name", F_Name);
                            formdata.append("L_Name", L_Name);
                            formdata.append("FA_Name", FA_Name);
                            formdata.append("National_Code", National_Code);
                            formdata.append("Identity_Code", Identity_Code);
                            formdata.append("DateOfBirthday", DateOfBirthday);
                            formdata.append("Sodor_City", Sodor_City);
                            formdata.append("identity", identity);
                            formdata.append("meli", meli);

                            var requestOptions = {
                              method: "POST",
                              body: formdata,
                              redirect: "follow",
                            };

                            fetch(
                              `${process.env.REACT_APP_BASE_API_URL}/api/user/update-relation`,
                              requestOptions,
                            )
                              .then((response) => response.text())
                              .then((result) => {
                                //this.toggleBlocking();
                                if (result !== null) {
                                  var myObject = JSON.parse(result);
                                  if (myObject.status === 0) {
                                    this.setState(
                                      {
                                        errorMessage: "اطلاعات شما ارسال شد، منتظر تایید آن توسط واحد منابع انسانی باشید.",
                                      },
                                      function () {
                                        this.toggleError();
                                        this.toggleUpdateRelation();
                                      },
                                    );
                                    this.setState({ isRelationLoading: false });
                                    this.getAllUserRelation();
                                  } else {
                                    this.setState(
                                      { errorMessage: myObject.message },
                                      function () {
                                        this.toggleError();
                                      },
                                    );
                                    this.setState({ isRelationLoading: false });
                                  }
                                }
                              })
                              .catch((error) => console.log("error", error));
                          } else {
                            const errorMessage =
                              "محل صدور تحت تکفل خود را مشخص نمایید.";
                            this.toggleErrorMessage(errorMessage);
                            this.toggleError();
                          }
                        } else {
                          const errorMessage =
                            "تاریخ تولد تحت تکفل را وارد نمایید.";
                          this.toggleErrorMessage(errorMessage);
                          this.toggleError();
                        }
                      } else {
                        const errorMessage =
                          "شماره شناسنامه تحت تکفل را وارد نمایید.";
                        this.toggleErrorMessage(errorMessage);
                        this.toggleError();
                      }
                    } else {
                      const errorMessage = "کدملی تحت تکفل را وارد نمایید.";
                      this.toggleErrorMessage(errorMessage);
                      this.toggleError();
                    }
                  } else {
                    const errorMessage = "نام پدر را وارد نمایید.";
                    this.toggleErrorMessage(errorMessage);
                    this.toggleError();
                  }
                } else {
                  const errorMessage = "نام خانوادگی تحت تکفل را وارد نمایید.";
                  this.toggleErrorMessage(errorMessage);
                  this.toggleError();
                }
              } else {
                const errorMessage = "نام تحت تکفل را وارد نمایید.";
                this.toggleErrorMessage(errorMessage);
                this.toggleError();
              }
            } else {
              const errorMessage = "نسبت فرد را انتخاب نمایید.";
              this.toggleErrorMessage(errorMessage);
              this.toggleError();
            }
          } else {
            const errorMessage = "جنسیت را انتخاب نمایید.";
            this.toggleErrorMessage(errorMessage);
            this.toggleError();
          }
        }
      }
      else {
        const errorMessage = "بارگذاری مدارک شناسایی الزامی است.";
        this.toggleErrorMessage(errorMessage);
        this.toggleError();
      }
    }
  };
  addComplaint = () => {
    const token = localStorage.getItem("token");
    const DepID = document.getElementById("ComplaintDepartment_ID").value;
    if (token !== null) {
      if (DepID !== null && DepID !== "") {
        const ComTitle = document.getElementById("ComplaintTitle").value;
        if (ComTitle !== null && ComTitle !== "") {
          const ComReason = document.getElementById("ComplaintReason").value;
          if (ComReason !== null && ComReason !== "") {
            const ComDescribe = document.getElementById("ComplaintDescribe")
              .value;
            if (ComDescribe !== null && ComDescribe !== "") {
              this.toggleBlocking();
              var formdata = new FormData();
              formdata.append("token", token);
              formdata.append("DepID", DepID);
              formdata.append("ComTitle", ComTitle);
              formdata.append("ComReason", ComReason);
              formdata.append("ComDescribe", ComDescribe);
              var Reason_document = $("#inputDoc").prop("files")[0];
              if (Reason_document) {
                if (Reason_document.size <= 10080000) {
                  formdata.append("Reason_Doc", Reason_document);
                }
              }
              var requestOptions = {
                method: "POST",
                body: formdata,
                redirect: "follow",
              };

              fetch(
                `${process.env.REACT_APP_BASE_API_URL}/api/complaints/add-complaint`,
                requestOptions,
              )
                .then((response) => response.text())
                .then((result) => {
                  this.toggleBlocking();
                  if (result !== null) {
                    var myObject = JSON.parse(result);
                    if (myObject.status === 0) {
                      if (this.state.isError !== true) {
                        this.setState(
                          { errorMessage: "پیشنهاد شما در سامانه ثبت شد." },
                          function () {
                            this.toggleError();
                          },
                        );
                      }
                      this.setState({ snNumberComplaint: null }, function () {
                        if (this.state.isModal === true) this.toggleModal();
                      });
                      this.getUserComplaints(1);
                    } else {
                      this.setState(
                        { errorMessage: myObject.message },
                        function () {
                          this.toggleError();
                        },
                      );
                    }
                  }
                })
                .catch((error) => console.log("error", error));
            } else {
              const errorMessage =
                "شرح پیشنهاد خود را به صورت کامل وارد نمایید.";
              this.toggleErrorMessage(errorMessage);
              this.toggleError();
            }
          } else {
            const errorMessage =
              "دلایل ارائه پیشنهاد خود را به صورت کامل وارد نمایید.";
            this.toggleErrorMessage(errorMessage);
            this.toggleError();
          }
        } else {
          const errorMessage = "عنوان پیشنهاد خود را به صورت کامل وارد نمایید.";
          this.toggleErrorMessage(errorMessage);
          this.toggleError();
        }
      } else {
        const errorMessage = "واحد مربوطه را مشخص نمایید.";
        this.toggleErrorMessage(errorMessage);
        this.toggleError();
      }
    }
  };
  getFullProfile = () => {
    //console.log("APP-Get User Info");
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/user/get-user-info`,
        requestOptions,
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState({ userJson: myObject.data }, function () {
                // this.getBudget();
              });
            } else {
              if (myObject.message === "عدم مجوز جهت دریافت اطلاعات") {
                localStorage.clear();
              }
            }
          }
        })
        .catch((error) => console.log(error));
    }
  };
  getUserLoanInfo = () => {
    //console.log("APP-Get User Loan Info");
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/user/get-user-loan-info`,
        requestOptions,
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState({ userLoanInfoJson: myObject.data }, function () {
                // this.getBudget();
              });
            } else {
            }
          }
        })
        .catch((error) => console.log(error));
    }
  };
  getallUserSurvey = () => {
    // console.log("APP-Get User Complaints");
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/refahi/get-all-user-survey`,
        requestOptions,
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState({ usersurveyJson: myObject.data }, function () {
                // console.log("Fetch All Complaints Records");
              });
            } else {
              // console.log("Fetch Complaints : " + myObject.message);
            }
          }
        })
        .catch((error) => console.log(error));
    }
  };
  getUserComplaints = (pageindex) => {
    // console.log("APP-Get User Complaints");
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/complaints/get-user-complaints?page=1`,
        requestOptions,
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState({ complaintsJson: myObject.data }, function () {
                // console.log("Fetch All Complaints Records");
              });
            } else {
              // console.log("Fetch Complaints : " + myObject.message);
            }
          }
        })
        .catch((error) => console.log(error));
    }
  };
  saveFullProfile = (data) => {
    // console.log("APP-Edit User Data");
    const token = localStorage.getItem("token");
    if (token !== null) {
      let imgUser = document.getElementById("inputId");
      var formdata = new FormData();
      formdata.append("first_name", data.userForm.first_name);
      formdata.append("last_name", data.userForm.last_name);
      formdata.append("bank_name", data.userForm.bank_name);
      formdata.append("bank_shaba", data.userForm.bank_shaba);
      formdata.append("national_id", data.userForm.national_id);
      formdata.append("shop_name", data.userForm.shop_name);
      formdata.append("address", data.userForm.address);
      formdata.append("postal_code", data.userForm.postal_code);
      if (
        imgUser.files &&
        imgUser.files.length > 0 &&
        imgUser.files[0].size <= 4000000
      ) {
        formdata.append("profile_picture", imgUser.files[0]);
      }
      formdata.append("token", token);
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/user/save-full-profile`,
        requestOptions,
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState(
                { errorMessage: "اطلاعات با موفقیت به روزرسانی شد." },
                function () {
                  this.toggleError();
                },
              );
              this.setState({ userJson: myObject.data }, function () {
                // console.log("Edit User Successfully done!");
              });
              this.getFullProfile();
            } else {
              // console.log("Edit User Data : " + myObject.message);
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };
  getChatroom = () => {
    // console.log("APP-Get all town");
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);

      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/get-chatroom`,
        requestOptions,
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState({ chatroomJson: myObject.data }, function () {
                // console.log("Get All Chat Rooms");
              });
            } else {
              // console.log("Fetch Town : " + myObject.message);
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };
  clearCalender = () => {
    this.setState({ calenderJson: [] });
  };
  getCalender = (hotel, e, v) => {
    //console.log("APP-Get Calender");
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);
      formdata.append("Hotel", hotel.value);
      formdata.append("Year", e.value);
      formdata.append("Month", v.value);
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/refahi/get-calender`,
        requestOptions,
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState({ calenderJson: myObject.data });
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };
  getComplaintsDepartment = () => {
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/complaints/get-complaints-department`,
        requestOptions,
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState(
                { complaintsDepartment: myObject.data },
                function () {
                  //this.clearCalender();
                },
              );
            } else {
              //console.log("Fetch Town : " + myObject.message);
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };
  getCity = () => {
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/user/get-city`,
        requestOptions,
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState({ cityJson: myObject.data }, function () { });
            } else {
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };
  getSalaryMonth = (year) => {
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);
      formdata.append("Year", year);
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/user/get-salary-month`,
        requestOptions,
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState({ monthJson: myObject.data }, function () { });
            } else {
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };
  getSalaryYear = () => {
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/user/get-salary-year`,
        requestOptions,
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState({ yearJson: myObject.data }, function () { });
            } else {
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };
  getYear = () => {
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/user/get-year`,
        requestOptions,
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState({ yearJson: myObject.data }, function () { });
            } else {
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };
  getLoanReason = () => {
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/refahi/get-loan-reason`,
        requestOptions,
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState({ userLoanReason: myObject.data }, function () {
                //this.clearCalender();
                //console.log(this.state.calenderJson);
              });
            } else {
              // console.log("Fetch Town : " + myObject.message);
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };
  getCalenderPlace = () => {
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/refahi/get-calender-place`,
        requestOptions,
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState({ calenderPlaceJson: myObject.data });
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };
  getCalenderYear = (e) => {
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);
      formdata.append("Hotel", e.value);
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/refahi/get-calender-year`,
        requestOptions,
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState({ calenderYearJson: myObject.data });
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };
  getCalenderMonth = (hotel, e) => {
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);
      formdata.append("Hotel", hotel.value);
      formdata.append("Year", e.value);
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/refahi/get-calender-Month`,
        requestOptions,
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState({ calenderMonthJson: myObject.data });
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };
  checkinLogin = () => {
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/user/checkin-login`,
        requestOptions,
      )
        .then((response) => response.text())
        .then((result) => {
          //console.log("result:", result);
          if (result !== null) {
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState({ isLogin: true });
            } else {
              this.setState({ isLogin: false });
              const parms = window.location.pathname;
              if (parms !== "/login") return (window.location = "/login");
            }
          }
        })
        .catch((error) => console.log("error", error));
    } else {
      console.log("Token Not Found");
      this.setState({ isLogin: false });
      const parms = window.location.pathname;
      if (parms !== "/login") return (window.location = "/login");
    }
  };
  getUserLoanRequest = () => {
    //console.log("APP-Get User Loan Request");
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);

      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/refahi/get-user-loan-request`,
        requestOptions,
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            // console.log(result);
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState({ userLoanRequestJson: myObject.data }, function () {
                //console.log("Get All Loan Request");
              });
            } else {
              //console.log("Fetch Town : " + myObject.message);
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };
  getUserInsRequest = (tarhRef) => {
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);
      formdata.append("TarhRef", tarhRef)
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/refahi/get-user-ins-request`,
        requestOptions,
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            // console.log(result);
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState({ userInsRequestJson: myObject.data }, function () {
                // console.log("Get All Chat Rooms");
              });
            } else {
              // console.log("Fetch Town : " + myObject.message);
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };
  getUserCermonyRequest = () => {
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);

      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/refahi/get-user-cermony-request`,
        requestOptions,
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            // console.log(result);
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState(
                { userCermonyRequestJson: myObject.data },
                function () {
                  // console.log("Get All Chat Rooms");
                },
              );
            } else {
              // console.log("Fetch Town : " + myObject.message);
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };
  getAllUserRelation = () => {
    //console.log("APP-Get All User Relation");
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);

      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/refahi/get-all-relation`,
        requestOptions,
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            this.setState({ userRelationsJson: null });
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState({ userRelationsJson: myObject.data }, function () {
                //console.log(this.state.userRelationsJson);
              });
            } else {
              // console.log("Fetch Town : " + myObject.message);
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };
  getUserRelation = (e) => {
    //console.log("APP-Get User Request");
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);
      formdata.append("RelationID", e);
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/refahi/get-relation`,
        requestOptions,
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            // console.log(result);
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState({ userRelationJson: myObject.data[0] }, function () {
                //console.log(myObject.data[0]);
                this.getCity();
                this.toggleUpdateRelation();
              });
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };
  getUserRequest = () => {
    //console.log("APP-Get User Request");
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);

      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/refahi/get-user-request`,
        requestOptions,
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            // console.log(result);
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState({ userRequestJson: myObject.data }, function () {
                // console.log("Get All Chat Rooms");
              });
            } else {
              // console.log("Fetch Town : " + myObject.message);
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };
  getChatMessageUnseen = () => {
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);

      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/get-chatroom-messages-unseen`,
        requestOptions,
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState({ unSeen: myObject.data });
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };
  declineLoanRequest = (e) => {
    //console.log("APP-Get User Request");
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);
      formdata.append("ID_Request", e);
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/refahi/del-user-loan-request`,
        requestOptions,
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            // console.log(result);
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.getUserLoanRequest();
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };
  SubmitLoanRequest = (e) => {
    //console.log("APP-Get User Request");
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);
      formdata.append("ID_Request", e);
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/user/add-loan-request-force`,
        requestOptions,
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            // console.log(result);
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.getUserLoanRequest();
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };
  declineRequest = (e) => {
    //console.log("APP-Get User Request");
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);
      formdata.append("ID_Request", e);
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/refahi/del-user-request`,
        requestOptions,
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            // console.log(result);
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.getUserRequest();
            } else {
              this.setState({ errorMessage: myObject.message }, function () {
                this.toggleError();
              });
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };
  acceptReservation = (e) => {
    //console.log("APP-Get User Request");
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);
      formdata.append("ID_Request", e);
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/refahi/accept-user-request-reservation`,
        requestOptions,
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.getUserRequest();
            } else {
              this.setState({ errorMessage: myObject.message }, function () {
                this.toggleError();
              });
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };
  participateSurvey = (e) => {
    //console.log("APP-Get Survey");
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);
      formdata.append("ID_Survey", e);
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/refahi/get-survey`,
        requestOptions,
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            //console.log(result);
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState({ surveyJson: myObject }, function () {
                // console.log(this.state.surveyJson);
                this.setState({ isSurvey: true });
              });
            } else {
              this.setState({ errorMessage: myObject.message }, function () {
                this.toggleError();
              });
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };
  getAllCandidate = () => {
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);

      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/user/get-all-candidate`,
        requestOptions,
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            this.setState({ candidateJson: null });
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState({ candidateJson: myObject.candidate }, function () {
                //console.log(this.state.candidateJson);
              });
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };
}

export default SalcoAPP;
